export const multiIndexOf = (arr, el) => {
  var idxs = []
  for (var i = arr.length - 1; i >= 0; i--) {
    if (arr[i] === el) {
      idxs.unshift(i)
    }
  }
  return idxs
}
